import { render, staticRenderFns } from "./ListTaxConfigs.vue?vue&type=template&id=6857883f&"
import script from "./ListTaxConfigs.vue?vue&type=script&lang=js&"
export * from "./ListTaxConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6857883f')) {
      api.createRecord('6857883f', component.options)
    } else {
      api.reload('6857883f', component.options)
    }
    module.hot.accept("./ListTaxConfigs.vue?vue&type=template&id=6857883f&", function () {
      api.rerender('6857883f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Listing/ListTaxConfigs.vue"
export default component.exports